export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Arrow-Down-Gray-c940f5a83d81ca2dcfa25ea448b64a43.svg";